import { render, staticRenderFns } from "./InstrumentsModal.vue?vue&type=template&id=5ce30b60&scoped=true"
import script from "./InstrumentsModal.vue?vue&type=script&lang=js"
export * from "./InstrumentsModal.vue?vue&type=script&lang=js"
import style0 from "./InstrumentsModal.vue?vue&type=style&index=0&id=5ce30b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce30b60",
  null
  
)

export default component.exports